/**
 * External Dependencies
 */
import 'jquery';
import 'bootstrap';
import lozad from 'lozad';
import animations from './components/animations';
import heroVideo from './components/heroVideo';
import hamburgerMenu from './components/hamburgerMenu';
import navBackground from './components/navBackground';
import scrollspy from './components/scrollspy';

$(() => {
	heroVideo();
	hamburgerMenu();
	navBackground();
	scrollspy();
	animations();

	// Lazad for lazy-load
	const observer = lozad();
	observer.observe();
});